import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import {
  MDBBox,
  MDBBtn,
  MDBBtnGroup,
  MDBIcon,
  MDBListGroup,
  MDBListGroupItem,
  MDBInput,
} from 'mdbreact';
import WebGlApp from 'webgl';
import { useLogout } from 'hooks/useLogout';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import jwt_decode from 'jwt-decode';
import { setCompanyUsers, setProjects,setUser } from 'actions/user';
import { setJWT, tokenRef } from 'api';
import Loading from 'components/ui-components/loading';
import NoMeshModal from '../../components/NoMeshModal';
import addNotification from 'helpers/notify';
import { useHttp } from '../../hooks/useHttp';
import { getJsonFile  } from 'api/files/getJsonFile';
import { url,IFC_Url,urlWS } from 'api';
import { liveManifestUrl, legacyManifestUrl } from 'helpers/liveManifest';






import { Maybe } from 'helpers/maybeFunctor';
import { getProjects } from 'api/projects/getProjects';
import { useHttpWithCache } from 'hooks/useHtthWithCache';
import {
  findRecursiveInTree,
  UpdateGroupVisibility,
  flattenTree,
  generateSubprojectHashmap,
  generateSubprojectMeshesHashed,
  findRecursiveInTreeJsonIdHashmap,
  findRowInNodeMap,
  recordFromClick,
} from 'helpers/three';
import { scrollRowToCentre } from "helpers/scrollRowToCentre";
import { reportClientError } from "helpers/clientLog";
import { extractLeafUids } from 'hooks/useStreamingTreeNode';
import './SocketViewer.scss';
import {eventTrack,googleAnalytics4} from '../../helpers/ga4Helper'

import LoadingAdmin from "components/ui-components/loading";
import ErrorAdmin from "components/ui-components/Error";
import { mainAdminSetCompanies } from "actions/main-admin";
import { mainAdminGetCompanyDetails } from "api/users/mainAdminGetCompanyDetails";
import { mainAdminGetCompanies } from "api/users/mainAdminGetCompanies";
import ViewerEffectsButton from "components/Viewer/ViewerEffectsButton";
import ViewerViewButtons from "components/Viewer/ViewerViewButtons";
import ViewerToolbar from "components/Viewer/ViewerToolbar";
import { attachBuildingGrid } from "helpers/buildingGridLoad";

// Classify a pathsmapping entry as a streaming-pipeline file.
//
// See ModelViewer.jsx for the full rationale. Same classifier mirrored
// here because SocketViewer also iterates session.zipInfo.pathsmapping
// to build its legacy JSONs/GLBs lists. Without this, every streaming
// tile sidecar (tiles/tile_X.json.gz) would be treated as a legacy
// project JSON and fetched serially, blocking WebGlApp construction
// for several minutes on streaming-enabled sessions.
//
// Mirrors the C# IsStreamingPipelineFile classifier in
// R2FileUploadUtility — keep these two in sync if the exporter ever
// adds a new streaming-pipeline file type.
const isStreamingPipelineEntry = (name) => {
  if (!name) return false;
  const lower = String(name).replace(/^\/+/, "").toLowerCase();
  if (lower === "manifest.json" || lower === "manifest.json.gz") return true;
  if (lower.startsWith("tiles/")) return true;
  if (lower.startsWith("fragments/")) return true;
  if (
    lower.startsWith("library.") &&
    (lower.endsWith(".glb") || lower.endsWith(".glb.gz"))
  ) {
    return true;
  }
  return false;
};

const SocketViewer = props => {
  const { projectId, wsSessionId, token, companyId } = props;
  const dispatch = useDispatch();
  const logOut = useLogout();
  const viewerRef = useRef();
  const WebGL = useRef();
  const history = useHistory();

  const [userId, setUserId] = useState(null);

  // Add these new variables for WebSocket reconnection.
  // maxReconnectAttempts is intentionally Infinity — the user wants the viewer
  // to keep retrying forever after every disconnect. The exponential delay is
  // already capped at 10s in the onclose handler, so this stays bounded in
  // practice even with no attempt cap.
  const reconnectIntervalRef = useRef(null);
  const reconnectAttemptsRef = useRef(0);
  const maxReconnectAttempts = Infinity;
  const isIntentionalClose = useRef(false);








  useEffect(()=> {
    
    try {
      if(token) {
        const userInfo = jwt_decode(token);
         // console.log("userInfo",userInfo);
        localStorage.setItem(tokenRef, token);
        setJWT(token);
        setUserId(userInfo.id);
        dispatch(setUser(userInfo));
      }
    } catch(err){
      console.log(err);
      addNotification(err.message, 'danger');
      history.push('/');
    }
  }, [token])


  const userRedux = useSelector((s) => s.user.userInfo);
  const projectsRedux = useSelector(s => s.user.projects);
  const usersRedux = useSelector(s => s.user.users);
  

  const companiesRedux = useSelector((s) => s.mainAdmin.company);
  const companiesProjectsRedux = useSelector((s) => s.mainAdmin.company_projects);
  const allUsersRedux = useSelector((s) => s.mainAdmin.all_users);

  // One-shot drill-in for admin users — shapes one entry into
  // companiesProjectsRedux for the company that owns this viewer's
  // project. Gated by adminDrillInFiredRef so it runs at most once
  // per mount even though useHttpWithCache re-evaluates on every
  // render. Without this guard the dispatch loop hit React #185
  // on cold deep-link opens.
  const adminDrillInFiredRef = useRef(false);
  useEffect(() => {
    if (adminDrillInFiredRef.current) return;
    if (!userRedux?.admin) return;
    if (!companyId) return;
    // Already hydrated by another component or prior load? skip.
    if (companiesProjectsRedux
        && companiesProjectsRedux.some(c => String(c?._id) === String(companyId))) {
      adminDrillInFiredRef.current = true;
      return;
    }
    adminDrillInFiredRef.current = true;
    console.warn('[DIAG] SocketViewer drill-in START companyId=', companyId);
    mainAdminGetCompanyDetails(companyId)
      .then((detail) => {
        if (!detail) {
          console.warn('[DIAG] SocketViewer drill-in returned NO DETAIL');
          return;
        }
        const projCount = (detail.projects || []).length;
        const sessCount = (detail.projects || []).reduce(
          (n, p) => n + (Array.isArray(p?.sessions) ? p.sessions.length : 0), 0);
        console.warn('[DIAG] SocketViewer drill-in OK projects=', projCount,
          'sessions=', sessCount, 'lookingForProjectId=', projectId,
          'lookingForSessionId=', wsSessionId);
        const oneEntry = {
          ...(detail.company || { _id: companyId }),
          projects: detail.projects || [],
        };
        dispatch({
          type: "MAIN_ADMIN_SET_ALL_COMPANIES_PROJECTS",
          payload: [oneEntry],
        });
        dispatch({
          type: "MAIN_ADMIN_SET_ALL_USERS",
          payload: detail.users || [],
        });
      })
      .catch((err) => {
        console.warn("[DIAG] SocketViewer admin drill-in failed:", err?.message || err);
      });
  }, [userRedux?.admin, companyId, companiesProjectsRedux, dispatch]);


  function findProject()
  {

    var company = null;
    var project = null;

   if (companiesProjectsRedux && userRedux?.admin)
    {
      // The previous Maybe.of(...).value.projects chain blew up with
      // "Cannot read properties of undefined (reading 'projects')"
      // whenever companies.find() returned undefined — e.g. during the
      // brief window between SocketViewer mount and the admin drill-in
      // resolving, or when the hydrated company genuinely has no
      // matching project. The remount loop used to mask the throw;
      // with that fixed (see App.jsx render= migration, May-24) the
      // error now tears down the canvas. Rewrite with optional
      // chaining: same intent, safe when any level is null/empty.
      const targetCompany = companiesProjectsRedux.find(c =>
        Array.isArray(c?.projects) &&
        c.projects.some(p => p?._id === projectId)
      );
      company = targetCompany?.projects?.find(p => p?._id === projectId) ?? null;
   }
   

  if (projectsRedux && !userRedux?.admin && project == null) {
    
      project =  Maybe.of(projectsRedux).map(projects => {
    
        console.log(">>>>>>>>>>>>>>>>> projectsRedux", projectsRedux)
        return   projects.filter(project => project._id == projectId)[0]}).value; 

    }


    if (project) {
      return project;
    }

    if (company) {
      return company;
    }


  }


  const project = findProject()



  function findSession()
  {
    // Same null-safety rewrite as findProject above. Original Maybe
    // chains assumed companies.find() always hit, then chained
    // .value.projects.map(...) — which throws when companies.find()
    // returns undefined during pre-hydration renders.
    if (companiesProjectsRedux && userRedux?.admin) {
      const targetCompany = companiesProjectsRedux.find(c =>
        c && Array.isArray(c.projects) && c._id === companyId
      );
      return targetCompany?.projects
        ?.flatMap(p => (p && Array.isArray(p.sessions)) ? p.sessions : [])
        ?.find(s => s?._id === wsSessionId) ?? null;
    }

    if (projectsRedux && !userRedux?.admin) {
      return projectsRedux
        .flatMap(p => (p && Array.isArray(p.sessions)) ? p.sessions : [])
        .find(s => s?._id === wsSessionId) ?? null;
    }

    return null;
  }

 
  const neededSession =  findSession() 
    
 

    useEffect(() => {
      isMountedRef.current = true;
      console.warn('[DIAG] SocketViewer load-gate',
        'project=', project ? 'set' : 'null',
        'session=', neededSession ? 'set' : 'null',
        'usersRedux=', usersRedux ? 'set' : 'null',
        'allUsersRedux=', allUsersRedux ? 'set' : 'null',
        'projectsRedux=', projectsRedux ? 'set' : 'null',
        'companiesProjectsRedux=', companiesProjectsRedux ? `len${companiesProjectsRedux.length}` : 'null',
        'isGLOpend=', isGLOpend);
      if(isMountedRef.current && project && neededSession && (usersRedux || allUsersRedux) && (projectsRedux || companiesProjectsRedux)  && !isGLOpend) {
        console.warn('[DIAG] SocketViewer load-gate PASS — calling initializeAPI');
        setGLOpend(true);
      //  dispatch(initSession(userInfo));
        initializeAPI();
      }
      return () => (isMountedRef.current = false);
    }, [projectsRedux, companiesProjectsRedux, usersRedux,allUsersRedux, neededSession, project]);
  




     



  const isMountedRef = useRef(null);
  // THE SCROLL THIS PAGE NEVER HAD. The call was commented out (line ~1810
  // before this change), so a 3D click could find and light the right row and
  // the list would not move to it - and until tonight it could not even find
  // it, because both of its lookups asked for an undefined id. Owner,
  // 2026-10-21: "check that every other viewer is also working correctly".
  // A request carries its own number so clicking the SAME row twice is two
  // requests; holding the bare id meant React bailed out of the second.
  const scrollSeqRef = useRef(0);
  const [scrollRequest, setScrollRequest] = useState(null);
  const requestScroll = (rowId) => {
    if (!rowId) return;
    scrollSeqRef.current += 1;
    setScrollRequest({ key: String(rowId), n: scrollSeqRef.current });
  };

  useEffect(() => {
    if (!scrollRequest || !scrollRequest.key) return undefined;
    isMountedRef.current = true;
    const cancel = scrollRowToCentre(scrollRequest.key, {
      isAlive: () => isMountedRef.current,
      report: (r) => reportClientError("socketviewer/scroll", { message: JSON.stringify(r) }),
    });
    return () => { cancel(); };
  }, [scrollRequest]);

  const [meshesArray, setMeshes] = useState(null);
  const [hoverMesh, setHoverMesh] = useState({});
  const [clickedChild, setClickedChild] = useState([]);
  const [clickedUnmatchedChild, setClickedUnmatchedChild] = useState([]);
  //
  const [clickedExistingChild, setClickedExistingChild] = useState([]);
  const [clickedDemolitionChild, setClickedDemolitionChild] = useState([]);
  //


  //
  const [percentsLoaded, setPercentsLoaded] = useState(0);
  const [allowToResize, setAllowToResize] = useState(false);
  const [loading, setLoading] = useState(true);
   const [error, setError] = useState(false);
  const [modal, setModal] = useState(false);
  // WHY nothing could be shown, in the user's words. Empty keeps the old
  // sentence for any caller not yet converted.
  const [noMeshReason, setNoMeshReason] = useState('');

   const [selectGroups, setSelectGroups] = useState([]);
  const [isGLOpend, setGLOpend] = useState(false);
  const [isDataInitialized, setIsDataInitialized] = useState(false);

  let [modelNumber, setModelNumber] = useState(0);
  let [modelsNames, setModelsNames] = useState([]);
  let [jsons, setJsons] = useState([]);
  let [models, setModels ] = useState([]);

  // Debug overlay: GPU info + rolling FPS. Top-right corner of the
  // viewer. Visible ONLY in development environments — gated on the
  // host (localhost, 127.0.0.1, or predeployment.*). Production
  // (app.bidlight.com) never shows it. _gpuInfo is populated in
  // webgl/js/viewer/index.js right after the WebGLRenderer is
  // constructed.
  const isDebugOverlayEnabled = useMemo(() => {
    if (typeof window === 'undefined') return false;
    const host = window.location.hostname || '';
    return host === 'localhost'
        || host === '127.0.0.1'
        || host.startsWith('predeployment.');
  }, []);
  const [debugGpu, setDebugGpu] = useState(null);
  const [debugFps, setDebugFps] = useState(0);
  useEffect(() => {
    // Poll until the viewer is constructed and its renderer extracted
    // the GPU info. Stops on first successful read.
    let cancelled = false;
    const poll = () => {
      if (cancelled) return;
      const v = window.WebGL?.current?.viewer || WebGL?.current?.viewer;
      if (v && v._gpuInfo) {
        setDebugGpu(v._gpuInfo);
        return;
      }
      setTimeout(poll, 250);
    };
    poll();
    return () => { cancelled = true; };
  }, []);
  useEffect(() => {
    // rAF-based FPS counter. Cheap; just counts frames per second.
    let frames = 0;
    let last = performance.now();
    let rafId = 0;
    const tick = (now) => {
      frames++;
      if (now - last >= 1000) {
        setDebugFps(frames);
        frames = 0;
        last = now;
      }
      rafId = requestAnimationFrame(tick);
    };
    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, []);







//const [message, setMessage] = useState([]);
const message = useRef([]);
const [payload, setPayload] = useState(null);
// Per-sender selection sequence. Tracing only - see the sender below.
const selSeqRef = useRef(0);
const serverMessage = useRef([]);
const [ws, setWs] = useState(null);


////createdisctionary for data handling

const matched = useRef(new Map());
const unmatched = useRef(new Map());
const existing = useRef(new Map());
const demolition = useRef(new Map());
const disabled = useRef(new Map());
const meshes = useRef(new Map());
const unmatchedMeshes = useRef(new Map());
const existingMeshes = useRef(new Map());
const demolitionMeshes = useRef(new Map());

const disabledMeshes = useRef(new Map());

// [DIAG-EXPORT] One-shot tree-side summary, fired 6s after mount so
// the JSON fetch + the streaming tile registry have both settled.
// Reports per-bucket component counts so we can compare against
// the [DIAG-EXPORT] manifest line (tile.sceneInstanceCount) — a
// large delta means the exporter put elements in the JSON tree
// but the streaming pipeline missed them, or vice versa.
useEffect(() => {
  const tid = setTimeout(() => {
    try {
      console.warn(
        '[DIAG-EXPORT] tree',
        JSON.stringify({
          matched: meshes.current.size,
          unmatched: unmatchedMeshes.current.size,
          existing: existingMeshes.current.size,
          demolition: demolitionMeshes.current.size,
          disabled: disabledMeshes.current.size,
          total: meshes.current.size + unmatchedMeshes.current.size
            + existingMeshes.current.size + demolitionMeshes.current.size
            + disabledMeshes.current.size,
        })
      );
    } catch (e) { /* logging must not block */ }
  }, 6000);
  return () => clearTimeout(tid);
}, []);

// Tracks the "Enable/Disable Elements" toggle locally. Default false =
// disabled-tree elements are disabled+hidden (not visible). Synced with
// C# via the 'toggleDisabled' WS message.
const showDisabledRef = useRef(false);

// Viewer-side source of truth for "which uids are in the C# Disabled
// tree". Populated from:
//   - 'move' WS messages with target tree index 4 (add) or source 4 (remove)
//   - 'toggleDisabled' inbound payloads (full uid list from C#)
// Used so the applyDisabledBucket() helper can re-disable+hide the right
// uids even if streaming.state wasn't available at receive time (initial
// project load race).
const disabledTreeUidsRef = useRef(new Set());

const selectedMesh = useRef(null);

// Apply the current disabled-tree state to ViewerStateStore. The
// identifiers in disabledTreeUidsRef are C# Component.JsonId values
// (== component.$id from JSON), but ViewerStateStore is keyed by
// Revit UniqueId (meshInfo.UniqueId). The translation lives in the
// disabled.current Map populated by generateSubprojectHashmap on
// initial project load and by moveFromTreeAtoTreeB on tree moves.
//
// Self-heal for the page-reload race: if C# tells us a jsonId is in
// the Disabled tree but it does NOT appear in viewer's disabled.current
// (because the user moved it AFTER export and the session JSON we
// reloaded captures the pre-move tree positions), search the other 4
// trees and migrate the entry client-side. Without this, runtime moves
// silently get lost on every reload — C# stays consistent but the
// viewer reverts to the export-time tree placement and the next
// applyDisabledBucket pass can't resolve the uid.
//
// Returns true if the store was available (regardless of how many
// uids were resolved). False triggers a retry by the wrapper helper.
const applyDisabledBucket = () => {
  const store = WebGL.current?.viewer?.streaming?.state;
  if (!store) return false;
  const showAsEnabled = showDisabledRef.current;
  let resolved = 0, unresolved = 0, migrated = 0;
  const sourceTrees = [
    { tree: matched,    meshes: meshes },
    { tree: unmatched,  meshes: unmatchedMeshes },
    { tree: existing,   meshes: existingMeshes },
    { tree: demolition, meshes: demolitionMeshes },
  ];
  // Source of truth = `disabled.current` Map (the runtime tree-4
  // contents). disabledTreeUidsRef has historically been the iteration
  // source, but C# overwrites it with its own (sometimes stale)
  // authoritative list on every toggleDisabled, dropping runtime moves
  // into Disabled. Walking the Map directly ALSO covers the union of
  // entries we used to migrate in via the reload-race fallback below,
  // since those would already be in disabled.current.
  //
  // We still iterate via the ref AS A FALLBACK for items that C#
  // claims are disabled but haven't yet been added to disabled.current
  // (initial load before tree hydration completes).
  const iterIds = new Set(disabled.current.keys());
  disabledTreeUidsRef.current.forEach(id => iterIds.add(id));
  iterIds.forEach(jsonId => {
    try {
      let entry = disabled.current.get(jsonId);
      if (!entry) {
        // Not in disabled.current — find it in matched/unmatched/
        // existing/demolition and migrate to disabled. This is the
        // reload-race fix.
        for (const src of sourceTrees) {
          if (src.tree.current.has(jsonId)) {
            moveFromTreeAtoTreeB(src.tree, src.meshes, disabled, disabledMeshes, jsonId);
            entry = disabled.current.get(jsonId);
            migrated++;
            break;
          }
        }
      }
      const realUid = entry?.meshInfo?.UniqueId;
      if (!realUid) {
        unresolved++;
        return;
      }
      resolved++;
      store.disable(realUid);
      if (showAsEnabled) store.show(realUid);
      else store.hide(realUid);
    } catch (err) {
      // Per-uid errors are non-fatal; missing fragments during stream-
      // ing load are expected.
    }
  });
  console.log('[applyDisabledBucket] showAsEnabled=', showAsEnabled,
              'resolved=', resolved, 'migrated=', migrated,
              'unresolved=', unresolved,
              'totalInRef=', disabledTreeUidsRef.current.size);
  return true;
};

// Retry-apply for the case where streaming.state hasn't initialized yet
// when a 'toggleDisabled' or initial 'move' message arrives. Tries up to
// `maxRetries` times with `delayMs` between attempts. Defensive against
// the project-load race that was leaving the disabled tree visible.
const applyDisabledBucketWithRetry = (maxRetries = 20, delayMs = 500) => {
  let attempts = 0;
  const tryApply = () => {
    if (applyDisabledBucket()) return;
    attempts++;
    if (attempts < maxRetries) setTimeout(tryApply, delayMs);
  };
  tryApply();
};




// Create WebSocket connection function with reconnection logic
const createWebSocketConnection = useCallback(() => {
  if (isIntentionalClose.current) return;
  
  const wss = new WebSocket(`${urlWS}/${wsSessionId}`);
  
  wss.onopen = function() {
    console.log('WebSocket connected');
    reconnectAttemptsRef.current = 0;
    setWs(wss);

    // After every (re)connect, ask the C# peer to push its full selection state
    // so this viewer rebuilds correctly. C# answers with a 'sync' message that
    // wipes our cachedSelection and reapplies per-tree ids. Sent unconditionally:
    // on first connect the viewer's state is empty so the round-trip is harmless,
    // and on reconnect it brings us back in sync with whatever the C# UI did
    // while the socket was down.
    try {
      wss.send(JSON.stringify({
        roomid: `${wsSessionId}`,
        header: 'action',
        state: 'requestSync',
        body: '',
      }));
    } catch (e) {
      console.log('requestSync send failed', e);
    }
  };
  
  wss.onmessage = function (message) {
    let data = JSON.parse(message.data)
    console.log('>>data happened >>',data )

    // === EARLY HANDLER: toggleDisabled (C# → web) ===
    //
    // toggleDisabled bodies are JSON OBJECTS ({visible, uids}), not arrays.
    // The legacy pipeline below assumes body is always an array and does
    //   let arr = JSON.parse(data.body); arr.flatMap(...)
    // which throws TypeError when arr is an object — silently crashing the
    // entire onmessage handler for this message. Symptom: web→C# works
    // (web button fires its own local store calls before sending), but
    // C#→web never visibly takes effect because the inbound message
    // bombs out before reaching the case 'toggleDisabled' in the switch.
    //
    // Also bypasses the matched.current.size===0 guard below, which
    // shouldn't apply to toggleDisabled — that guard exists for messages
    // that need the tree maps populated (click/hide/etc.), but toggle
    // just flips a state flag and re-applies to whatever's currently in
    // disabled.current (empty is a no-op, which is fine).
    if (data && data.header === 'action' && data.state === 'toggleDisabled') {
      console.log('[toggleDisabled] inbound (early)', { body: data.body });
      try {
        let visible = null;
        let uids = null;
        const body = data.body;
        if (body === 'true' || body === '"true"') visible = true;
        else if (body === 'false' || body === '"false"') visible = false;
        else {
          const obj = typeof body === 'string' ? JSON.parse(body) : body;
          if (obj && typeof obj === 'object') {
            if (typeof obj.visible === 'boolean') visible = obj.visible;
            if (Array.isArray(obj.uids)) uids = obj.uids;
          }
        }
        if (visible !== null) {
          showDisabledRef.current = visible;
          if (uids && uids.length > 0) {
            disabledTreeUidsRef.current = new Set(uids);
          }
          applyDisabledBucketWithRetry();
          const btn = document.getElementById('enableDisableElementsBtn')
                    || document.getElementById('toggleDisabledBtn');
          if (btn) {
            if (visible) btn.classList.add('buttonEnabled');
            else btn.classList.remove('buttonEnabled');
          }
        }
      } catch (err) {
        console.warn('[toggleDisabled] early handler failed:', err);
      }
      return;
    }

    // Check if data is initialized before processing
    if (!matched.current || matched.current.size === 0) {
      console.log('Data not initialized yet, skipping message processing');
      return;
    }

    if (data) {
      // Defensive parse: legacy messages send body as a JSON-stringified
      // ARRAY ([treeIndex, "True", uid, uid, ...]). If a NEW non-array
      // body sneaks past the early-handler dispatch above (forward-compat
      // safety), arr ends up an object and the flatMap below throws,
      // killing the handler. Coerce to [] in that case so the rest of
      // the switch stays alive.
      let parsed = data.body.length ? JSON.parse(data.body) : []
      let arr = Array.isArray(parsed) ? parsed : []
      let i =0
      let selectors = {}
      let treeIndex = 0
      KeepSelected.current = [];
      // arr.map(item => {
      //   KeepSelected.current.push(item)
      // })
      KeepSelected.current = arr.flatMap(item => item);

    //  console.log('>>KeepSelected.current sliced >>',KeepSelected.current.slice(1,KeepSelected.current.length) )

    //  WebGL.current.viewer.cachedSelection.set(`${KeepSelected.current[0]}`, KeepSelected.current.length > 1?KeepSelected.current.slice(1,KeepSelected.current.length):[])
       console.log('>>arr >>',arr )
       if (WebGL.current && WebGL.current.viewer && WebGL.current.viewer.cachedSelection) {
         console.log('>>WebGL.current.viewer.cachedSelection >>',WebGL.current.viewer.cachedSelection )
       }
      // message.current = arr.flatMap(item => item)
     
      console.log('>>message.current >>',KeepSelected.current )
    
      let  selectedTree = null
    //  let  selectedTreeMeshes = null
      switch (arr[0]) {
        case '0':
          selectors={
            prevMeshes: 'prevMeshes',
            prevMaterials: 'prevMaterials',
            color: 'blue',
            treeIndex: 0,
          }
          treeIndex =0;
          selectedTree = matched;
        //  selectedTreeMeshes = meshes;
          break;

          case '1':
            selectors={
              prevMeshes: 'prevUnmatchedMeshes',
              prevMaterials: 'prevUnmatchedMaterials',
              color: 'red',
              treeIndex: 1,
            }
            treeIndex =1
            selectedTree = unmatched;
          //  selectedTreeMeshes = unmatchedMeshes;
            break;

            case '2':
              selectors={
                prevMeshes: 'prevExistingMeshes',
                prevMaterials: 'prevExistingMaterials',
                color: 'purple',
                treeIndex: 2,
              }
              treeIndex =2
              selectedTree = existing;
            //  selectedTreeMeshes = existingMeshes;
              break;
              case '3':
                selectors={
                  prevMeshes: 'prevDemolitionMeshes',
                  prevMaterials: 'prevDemolitionMaterials',
                  color: 'brown',
                  treeIndex: 3,
                }
                treeIndex =3
                selectedTree = demolition;
            //    selectedTreeMeshes = demolitionMeshes;
                break;

                case '4':
                  selectors={
                    prevMeshes: 'prevDisabledMeshes',
                    prevMaterials: 'prevDisabledMaterials',
                    color: 'gray',
                    treeIndex: 4,
                  }
                  treeIndex = 4
                  selectedTree = disabled;
                  break;
      
        default:
          break;
      } 
      switch (data.header) {
      
      
        case 'session':
          
        switch (data.state) {
          case 'create':
            break;
    
            case 'join':
    
    
            break;
    
    
            case 'leave':
            break;
        
        
          default:
            break;
        }
          
          break;
    
    

          case 'action':

            switch (data.state) {
              case 'click':
                console.log("click ");


               {
                if (arr.length === 1) {

                  console.log('resetting after click ')
                  resetSelection (selectedTree, selectors)
               } else {
                  // 'click' is now exclusive across trees: clear every other tree's
                  // selection before applying the new one. Mirrors the C# UI rule
                  // "plain click in tree X clears all other trees" so both ends
                  // converge to the same single-tree-at-a-time state.
                  // Ctrl-extend within the same tree still arrives as 'ctrlclick',
                  // which preserves siblings — see that case below.
                  const allTrees = [
                    { tree: matched,    selectors: { prevMeshes: 'prevMeshes',           prevMaterials: 'prevMaterials',           color: 'blue',   treeIndex: 0 } },
                    { tree: unmatched,  selectors: { prevMeshes: 'prevUnmatchedMeshes',  prevMaterials: 'prevUnmatchedMaterials',  color: 'red',    treeIndex: 1 } },
                    { tree: existing,   selectors: { prevMeshes: 'prevExistingMeshes',   prevMaterials: 'prevExistingMaterials',   color: 'purple', treeIndex: 2 } },
                    { tree: demolition, selectors: { prevMeshes: 'prevDemolitionMeshes', prevMaterials: 'prevDemolitionMaterials', color: 'brown',  treeIndex: 3 } },
                    { tree: disabled,   selectors: { prevMeshes: 'prevDisabledMeshes',   prevMaterials: 'prevDisabledMaterials',   color: 'gray',   treeIndex: 4 } },
                  ];
                  allTrees.forEach(({ tree, selectors: sel }) => {
                    if (sel.treeIndex !== treeIndex) {
                      resetSelection(tree, sel);
                    }
                  });
                }
                // === BULK FAST-PATH ===
                //
                // C# can send a single 'click' WS message with thousands
                // of jsonIds (the 4000+ shell-group select in C# fires
                // this). The per-item loop below runs an applicator pass
                // PER item, freezing the browser for seconds — pop-in/
                // pop-out can't recover because the JS thread isn't
                // yielding to CefSharp.
                //
                // For batches >= BULK_THRESHOLD, route through
                // viewer.bulkSelectSocket which calls
                // streamingState.bulkHighlight ONCE for the whole batch.
                // Applicator runs applyForUids once with all uids and
                // sets needsUpdate once per touched mesh, instead of N.
                // Roughly 100x speedup on large selections.
                let __bulkDone = false;
                const BULK_THRESHOLD = 50;
                if (arr.length >= 1 + BULK_THRESHOLD
                    && WebGL.current?.viewer?.bulkSelectSocket
                    && WebGL.current?.viewer?.streaming?.state) {
                  console.log('[click] bulk path, items=', arr.length - 1);
                  const __pairs = [];
                  for (let __k = 1; __k < arr.length; __k++) {
                    const __jId = arr[__k];
                    const __item = selectedTree.current.get(__jId);
                    const __uid = __item?.meshInfo?.UniqueId;
                    if (!__uid) continue;
                    __item.treeSelected = true;
                    __pairs.push({ uid: __uid, jsonId: __jId });
                  }
                  if (__pairs.length > 0) {
                    WebGL.current.viewer.bulkSelectSocket(__pairs, selectors);
                    __bulkDone = true;
                  }
                }

                if (!__bulkDone) arr.forEach(jsonID => {





                  if (i !==0)
                   {


                    if (i > 1) {
                      selectClick(selectedTree, jsonID,selectors, true)
                    }else if (i < 2 && arr.length !== 1)
                    {
                      selectClick(selectedTree, jsonID,selectors, false)
                    }






                  }
                  i++;

                })
              //  WebGL.current.viewer.targetItems()
              }



                break;
                case 'deselect':
                  console.log("deselect ");
                //  KeepSelected.current = [];
                 {

                  

                  arr.forEach(jsonID => {


                    if ( i !==0)
                     {  
                     
                     

               
                        deselectClick(selectedTree, jsonID,selectors)
                    
                    }
                     i++;
                    }
                  
                  
                  )
                 
                }

                
                
                  break;
        
                case 'ctrlclick': {
                  console.log("ctrlclick ");

                  // BULK FAST-PATH for large ctrl-extends. Ctrl-click preserves
                  // the existing selection so we pass skipClear=true to
                  // bulkSelectSocket — it bulk-highlights without wiping the
                  // tree's current prev* arrays. Same threshold as 'click'.
                  const CTRL_BULK_THRESHOLD = 50;
                  if (arr.length - 1 >= CTRL_BULK_THRESHOLD
                      && WebGL.current?.viewer?.bulkSelectSocket
                      && WebGL.current?.viewer?.streaming?.state) {
                    console.log('[ctrlclick] bulk path, items=', arr.length - 1);
                    const pairs = [];
                    for (let k = 1; k < arr.length; k++) {
                      const jId = arr[k];
                      const item = selectedTree.current.get(jId);
                      const uid = item?.meshInfo?.UniqueId;
                      if (!uid) continue;
                      item.treeSelected = true;
                      pairs.push({ uid, jsonId: jId });
                    }
                    if (pairs.length > 0) {
                      WebGL.current.viewer.bulkSelectSocket(pairs, selectors, { skipClear: true });
                    }
                    break;
                  }

                  arr.forEach(jsonID => {
                    if ( i !==0)
                    {

                      selectClick(selectedTree, jsonID,selectors,true)

                    }

                    i++;
                  })

                break;
                }
                case 'move':


                      let treeAIndex = parseInt(arr[0]) ;
                      let treeBIndex = parseInt(arr[1]) ;

                      // BULK FAST-PATH for large moves (e.g., move 4000 items
                      // matched→disabled). Per-item path calls store.disable/
                      // store.hide/store.enable/store.show per uid for tree-4
                      // transitions, each emitting an event → per-uid applicator
                      // pass = freeze. Bulk path: do data moves in a tight loop,
                      // collect uids by category, then call store.bulkDisable/
                      // bulkHide/bulkEnable/bulkShow once each at end.
                      // jsonIds start at arr[2] (arr[0] = src tree, arr[1] = dst).
                      const MOVE_BULK_THRESHOLD = 50;
                      const moveStore = WebGL.current?.viewer?.streaming?.state;
                      if (arr.length - 2 >= MOVE_BULK_THRESHOLD && moveStore) {
                        console.log('[move] bulk path', treeAIndex, '->', treeBIndex, 'items=', arr.length - 2);
                        const treeMap   = { 0: matched,   1: unmatched,        2: existing,        3: demolition,        4: disabled };
                        const meshesMap = { 0: meshes,    1: unmatchedMeshes,  2: existingMeshes,  3: demolitionMeshes,  4: disabledMeshes };
                        const src = treeMap[treeAIndex];
                        const srcM = meshesMap[treeAIndex];
                        const dst = treeMap[treeBIndex];
                        const dstM = meshesMap[treeBIndex];
                        if (src && dst) {
                          const toDisable = [];
                          const toEnable  = [];
                          for (let k = 2; k < arr.length; k++) {
                            const jsonID = arr[k];
                            moveFromTreeAtoTreeB(src, srcM, dst, dstM, jsonID);
                            try {
                              if (treeBIndex === 4 && treeAIndex !== 4) {
                                disabledTreeUidsRef.current.add(jsonID);
                                const entry = disabled.current.get(jsonID);
                                const realUid = entry?.meshInfo?.UniqueId;
                                if (realUid) toDisable.push(realUid);
                              } else if (treeAIndex === 4 && treeBIndex !== 4) {
                                disabledTreeUidsRef.current.delete(jsonID);
                                const destEntry = matched.current.get(jsonID)
                                              || unmatched.current.get(jsonID)
                                              || existing.current.get(jsonID)
                                              || demolition.current.get(jsonID);
                                const realUid = destEntry?.meshInfo?.UniqueId;
                                if (realUid) toEnable.push(realUid);
                              }
                            } catch (err) { /* non-fatal */ }
                          }
                          // Single batched applicator pass for all uids at once.
                          moveStore.beginBatch();
                          try {
                            if (toDisable.length > 0) {
                              moveStore.bulkDisable(toDisable);
                              if (!showDisabledRef.current) moveStore.bulkHide(toDisable);
                            }
                            if (toEnable.length > 0) {
                              moveStore.bulkEnable(toEnable);
                              moveStore.bulkShow(toEnable);
                            }
                          } finally {
                            moveStore.endBatch();
                          }
                          // Drop to the post-move resetSelection block below.
                          // The break is at the end of case 'move:' so we exit
                          // the switch after the resets fire, matching legacy.
                          // Use a sentinel to skip the per-item forEach.
                          var __moveBulkDone = true;
                        }
                      }
                      if (!__moveBulkDone)
                      arr.forEach(jsonID => {
                        if (treeAIndex === 0 && treeBIndex === 1 && i !==0 && i!==1)
                         { moveFromTreeAtoTreeB(matched,meshes,unmatched,unmatchedMeshes, jsonID)
                        }
                         if (treeAIndex === 0 && treeBIndex === 2 && i !==0 && i!==1)
                         { moveFromTreeAtoTreeB(matched,meshes,existing,existingMeshes, jsonID)}
                         if (treeAIndex === 0 && treeBIndex === 3 && i !==0 && i!==1)
                         { moveFromTreeAtoTreeB(matched,meshes,demolition,demolitionMeshes, jsonID)}


                         if (treeAIndex === 1 && treeBIndex === 0 && i !==0 && i!==1)
                         { moveFromTreeAtoTreeB(unmatched,unmatchedMeshes, matched,meshes, jsonID)}
                         if (treeAIndex === 1 && treeBIndex === 2 && i !==0 && i!==1)
                         { moveFromTreeAtoTreeB(unmatched,unmatchedMeshes,existing,existingMeshes, jsonID)}
                         if (treeAIndex === 1 && treeBIndex === 3 && i !==0 && i!==1)
                         { moveFromTreeAtoTreeB(unmatched,unmatchedMeshes,demolition, demolitionMeshes, jsonID)}



                         if (treeAIndex === 2 && treeBIndex === 0 && i !==0 && i!==1)
                         { moveFromTreeAtoTreeB(existing,existingMeshes, matched,meshes, jsonID)}
                         if (treeAIndex === 2 && treeBIndex === 1 && i !==0 && i!==1)
                         { moveFromTreeAtoTreeB(existing,existingMeshes,unmatched,unmatchedMeshes, jsonID)}
                         if (treeAIndex === 2 && treeBIndex === 3 && i !==0 && i!==1)
                         { moveFromTreeAtoTreeB(existing,existingMeshes,demolition,demolitionMeshes, jsonID)}



                         if (treeAIndex === 3 && treeBIndex === 0 && i !==0 && i!==1)
                         { moveFromTreeAtoTreeB(demolition, demolitionMeshes, matched,meshes, jsonID)}
                         if (treeAIndex === 3 && treeBIndex === 1 && i !==0 && i!==1)
                         { moveFromTreeAtoTreeB(demolition,demolitionMeshes, unmatched,unmatchedMeshes, jsonID)}
                         if (treeAIndex === 3 && treeBIndex === 2 && i !==0 && i!==1)
                         { moveFromTreeAtoTreeB(demolition,demolitionMeshes,existing,existingMeshes, jsonID)}

                        
                    
                          // NEW: move into/out of disabled (tree index 4).
                          if (treeAIndex === 0 && treeBIndex === 4 && i !==0 && i!==1)
                          { moveFromTreeAtoTreeB(matched,meshes, disabled,disabledMeshes, jsonID) }
                          if (treeAIndex === 1 && treeBIndex === 4 && i !==0 && i!==1)
                          { moveFromTreeAtoTreeB(unmatched,unmatchedMeshes, disabled,disabledMeshes, jsonID) }
                          if (treeAIndex === 2 && treeBIndex === 4 && i !==0 && i!==1)
                          { moveFromTreeAtoTreeB(existing,existingMeshes, disabled,disabledMeshes, jsonID) }
                          if (treeAIndex === 3 && treeBIndex === 4 && i !==0 && i!==1)
                          { moveFromTreeAtoTreeB(demolition,demolitionMeshes, disabled,disabledMeshes, jsonID) }

                          if (treeAIndex === 4 && treeBIndex === 0 && i !==0 && i!==1)
                          { moveFromTreeAtoTreeB(disabled,disabledMeshes, matched,meshes, jsonID) }
                          if (treeAIndex === 4 && treeBIndex === 1 && i !==0 && i!==1)
                          { moveFromTreeAtoTreeB(disabled,disabledMeshes, unmatched,unmatchedMeshes, jsonID) }
                          if (treeAIndex === 4 && treeBIndex === 2 && i !==0 && i!==1)
                          { moveFromTreeAtoTreeB(disabled,disabledMeshes, existing,existingMeshes, jsonID) }
                          if (treeAIndex === 4 && treeBIndex === 3 && i !==0 && i!==1)
                          { moveFromTreeAtoTreeB(disabled,disabledMeshes, demolition,demolitionMeshes, jsonID) }

                          // Maintain viewer-side source-of-truth set for
                          // tree-4 membership AND drive ViewerStateStore so
                          // moved items go gray+hidden on arrival. Translates
                          // C# jsonID → meshInfo.UniqueId via the disabled
                          // Map that moveFromTreeAtoTreeB just populated
                          // (or just emptied for the move-out path).
                          if (i !== 0 && i !== 1) {
                            try {
                              if (treeBIndex === 4 && treeAIndex !== 4) {
                                disabledTreeUidsRef.current.add(jsonID);
                                const store = WebGL.current?.viewer?.streaming?.state;
                                const entry = disabled.current.get(jsonID);
                                const realUid = entry?.meshInfo?.UniqueId;
                                if (store && realUid) {
                                  store.disable(realUid);
                                  if (!showDisabledRef.current) {
                                    store.hide(realUid);
                                  }
                                } else {
                                  applyDisabledBucketWithRetry();
                                }
                              } else if (treeAIndex === 4 && treeBIndex !== 4) {
                                disabledTreeUidsRef.current.delete(jsonID);
                                const store = WebGL.current?.viewer?.streaming?.state;
                                // After moveFromTreeAtoTreeB, jsonID lives in
                                // the DEST tree's Map. Try each in order.
                                const destEntry = matched.current.get(jsonID)
                                              || unmatched.current.get(jsonID)
                                              || existing.current.get(jsonID)
                                              || demolition.current.get(jsonID);
                                const realUid = destEntry?.meshInfo?.UniqueId;
                                if (store && realUid) {
                                  store.enable(realUid);
                                  store.show(realUid);
                                }
                              }
                            } catch (err) {
                              // Per-uid errors are non-fatal.
                            }
                          }

                        i++;
                       
                      })

    
                      selectors={
                        prevMeshes: 'prevMeshes',
                        prevMaterials: 'prevMaterials',
                        color: 'blue',
                        treeIndex: 0,
                      }
                       resetSelection (matched, selectors)
                       selectors={
                         prevMeshes: 'prevUnmatchedMeshes',
                         prevMaterials: 'prevUnmatchedMaterials',
                         color: 'red',
                         treeIndex: 1,
                       }
                       resetSelection (unmatched, selectors)
                       selectors={
                         prevMeshes: 'prevExistingMeshes',
                         prevMaterials: 'prevExistingMaterials',
                         color: 'purple',
                         treeIndex: 2,
                       }
                       resetSelection (existing, selectors)
                       selectors={
                         prevMeshes: 'prevDemolitionMeshes',
                         prevMaterials: 'prevDemolitionMaterials',
                         color: 'brown',
                         treeIndex: 3,
                       }
                       resetSelection (demolition, selectors)
                            
                       
                       // NEW: reset disabled selection too.
                      selectors={
                        prevMeshes: 'prevDisabledMeshes',
                        prevMaterials: 'prevDisabledMaterials',
                        color: 'gray',
                        treeIndex: 4,
                      }
                      resetSelection (disabled, selectors)
                     

                    break;

      
                case 'sync': {
                  // [PERF DIAG — May-24] Time the whole sync handler so
                  // we can see if C#-driven selection is what's killing
                  // FPS. Remove once tuned.
                  const __syncT0 = performance.now();
                  // Full selection-state snapshot from the C# peer. Wipe every
                  // tree's selection in the viewer, then replay each tree group
                  // exactly as in a 'click' but without the cross-tree exclusivity
                  // dance — 'sync' is already authoritative across all trees.
                  //
                  // Body layout: ["0", id, id, "1", id, "2", id, ...] — flat
                  // list of (treeIndex, ids...) groups. Empty body = "peer has
                  // no selection," in which case we just clear everything.
                  console.warn('[PERF sync] start, body.length=' + arr.length);
                  const allTrees = [
                    { tree: matched,    selectors: { prevMeshes: 'prevMeshes',           prevMaterials: 'prevMaterials',           color: 'blue',   treeIndex: 0 } },
                    { tree: unmatched,  selectors: { prevMeshes: 'prevUnmatchedMeshes',  prevMaterials: 'prevUnmatchedMaterials',  color: 'red',    treeIndex: 1 } },
                    { tree: existing,   selectors: { prevMeshes: 'prevExistingMeshes',   prevMaterials: 'prevExistingMaterials',   color: 'purple', treeIndex: 2 } },
                    { tree: demolition, selectors: { prevMeshes: 'prevDemolitionMeshes', prevMaterials: 'prevDemolitionMaterials', color: 'brown',  treeIndex: 3 } },
                    { tree: disabled,   selectors: { prevMeshes: 'prevDisabledMeshes',   prevMaterials: 'prevDisabledMaterials',   color: 'gray',   treeIndex: 4 } },
                  ];
                  // Step 1: clear every tree.
                  allTrees.forEach(({ tree, selectors: sel }) => resetSelection(tree, sel));

                  // Step 2: parse the flat body into per-tree id buckets.
                  const buckets = { 0: [], 1: [], 2: [], 3: [], 4: [] };
                  let curTree = -1;
                  for (const tok of arr) {
                    const asInt = parseInt(tok, 10);
                    if (!Number.isNaN(asInt) && tok.length <= 2 && asInt >= 0 && asInt <= 4) {
                      curTree = asInt;
                    } else if (curTree >= 0) {
                      buckets[curTree].push(tok);
                    }
                  }

                  // Step 3: apply each bucket. Use the same selectClick sequence
                  // a multi-id 'click' would use: first id = plain (replaces), rest = ctrl-extend.
                  //
                  // BULK FAST-PATH: when a single bucket is huge (e.g., 4000+
                  // shell-group items arriving as a 'sync' full-state replace),
                  // route through viewer.bulkSelectSocket so the applicator runs
                  // ONE pass with all uids instead of N. Without this, per-item
                  // selectClick → onClickChildInListSocket → applyForUids per
                  // item freezes the browser for seconds. Same threshold as the
                  // 'click' case below.
                  const SYNC_BULK_THRESHOLD = 50;
                  allTrees.forEach(({ tree, selectors: sel }) => {
                    const ids = buckets[sel.treeIndex];
                    if (!ids || !ids.length) return;

                    if (ids.length >= SYNC_BULK_THRESHOLD
                        && WebGL.current?.viewer?.bulkSelectSocket
                        && WebGL.current?.viewer?.streaming?.state) {
                      console.log('[sync] bulk path tree=', sel.treeIndex, 'items=', ids.length);
                      const pairs = [];
                      for (const jId of ids) {
                        const item = tree.current.get(jId);
                        const uid = item?.meshInfo?.UniqueId;
                        if (!uid) continue;
                        item.treeSelected = true;
                        pairs.push({ uid, jsonId: jId });
                      }
                      if (pairs.length > 0) {
                        WebGL.current.viewer.bulkSelectSocket(pairs, sel);
                        return; // skip per-item path for this bucket
                      }
                    }

                    ids.forEach((jsonID, idx) => {
                      selectClick(tree, jsonID, sel, idx > 0);
                    });
                  });
                  // [PERF DIAG] sync handler finished — total time + bucket sizes
                  const __syncDur = performance.now() - __syncT0;
                  console.warn('[PERF sync] done in ' + __syncDur.toFixed(1) + 'ms ' +
                    'buckets={0:' + (buckets[0]?.length||0) + ',1:' + (buckets[1]?.length||0) +
                    ',2:' + (buckets[2]?.length||0) + ',3:' + (buckets[3]?.length||0) +
                    ',4:' + (buckets[4]?.length||0) + '}');
                  break;
                }
                case 'toggleDisabled': {
                  // Diagnostic: prove the message arrived from C#. Pair this
                  // with the C#-side [ToggleDisabled→Web] log so we can tell
                  // the relay-routing direction is working when the C# button
                  // is clicked and the message doesn't visibly take effect.
                  console.log('[toggleDisabled] inbound', { bodyType: typeof data.body, body: data.body });
                  // C# Disabled-tab toggle clicked. Body is either a bare
                  // bool ("true" / "false") for the round-trip from our own
                  // viewer button click, or a JSON object
                  // { visible: bool, uids: [...] } for the C#-initiated case
                  // where C# is the source of truth for which uids live in
                  // the Disabled tree.
                  //
                  // Semantics: tree-4 membership puts items in the disabled
                  // bucket (gray ghosted rendering, set up automatically by
                  // the 'move' handler). The toggle only controls whether
                  // those gray items ALSO go into the hidden bucket — i.e.,
                  // "Hide disabled" = invisible, "Show disabled" = gray.
                  let visible = null;
                  let uids = null;
                  try {
                    const body = data.body;
                    if (body === 'true' || body === '"true"') visible = true;
                    else if (body === 'false' || body === '"false"') visible = false;
                    else {
                      const obj = typeof body === 'string' ? JSON.parse(body) : body;
                      if (obj && typeof obj === 'object') {
                        if (typeof obj.visible === 'boolean') visible = obj.visible;
                        if (Array.isArray(obj.uids)) uids = obj.uids;
                      }
                    }
                  } catch (err) {
                    console.warn('[toggleDisabled] body parse failed:', err);
                  }

                  if (visible === null) break;

                  showDisabledRef.current = visible;

                  // C# is authoritative for the uid list (walks
                  // project.DisabledSubprojects). Merge its uids into our
                  // local source-of-truth set so subsequent applies (and
                  // the toolbar button) have the data even when
                  // disabled.current Map is empty on initial load.
                  if (uids && uids.length > 0) {
                    disabledTreeUidsRef.current = new Set(uids);
                  }

                  // Always keep tree-4 uids in the disabled bucket (gray
                  // ghosted marker). The toggle only flips the hidden
                  // bucket for those uids: visible=false → also hidden;
                  // visible=true → revert to gray-but-visible.
                  applyDisabledBucketWithRetry();

                  // Sync the viewer toolbar button's visual state without
                  // re-broadcasting (would ping-pong with C#).
                  const btn = document.getElementById('enableDisableElementsBtn')
                            || document.getElementById('toggleDisabledBtn');
                  if (btn) {
                    if (visible) btn.classList.add('buttonEnabled');
                    else btn.classList.remove('buttonEnabled');
                  }
                  break;
                }

                case 'hide': {
                  // Body layout: [treeIndex, "True"|"False", jsonId, jsonId, ...].
                  // `i` is a per-message cursor used by the skip guards (i !== 0
                  // && i !== 1) so the treeIndex / visible header tokens don't
                  // get fed into hide().
                  let i = 0;
                  const hideTreeIndex = parseInt(arr[0], 10);
                  let visible = (arr[1] === 'True');

                  // BULK FAST-PATH: when the user hides/shows 50+ leaf items in
                  // one shot (typical: "Hide all selected" with thousands of
                  // selected items), the per-item hide() helper calls store.hide
                  // / store.show per uid, each emitting an event that triggers
                  // applyForUids([uid]) — N applicator passes + N GL upload
                  // triggers. Routing through store.bulkHide / store.bulkShow
                  // emits ONE event with all uids, one applyForUids pass,
                  // one needsUpdate per touched mesh.
                  const HIDE_BULK_THRESHOLD = 50;
                  const hideTreeMap = hideTreeIndex === 0 ? matched
                                  : hideTreeIndex === 1 ? unmatched
                                  : hideTreeIndex === 2 ? existing
                                  : hideTreeIndex === 3 ? demolition
                                  : hideTreeIndex === 4 ? disabled : null;
                  const hideStore = WebGL.current?.viewer?.streaming?.state;
                  if (hideTreeMap && hideStore && arr.length - 2 >= HIDE_BULK_THRESHOLD) {
                    console.log('[hide] bulk path tree=', hideTreeIndex, 'visible=', visible, 'items=', arr.length - 2);
                    const hideUids = [];
                    for (let k = 2; k < arr.length; k++) {
                      const jId = arr[k];
                      const item = hideTreeMap.current.get(jId);
                      const uid = item?.meshInfo?.UniqueId;
                      if (!uid) continue;
                      item.treeVisible = visible;
                      hideUids.push(uid);
                    }
                    if (hideUids.length > 0) {
                      if (visible) hideStore.bulkShow(hideUids);
                      else hideStore.bulkHide(hideUids);
                    }
                    break;
                  }

                  arr.forEach(jsonID => {
                    if (i !== 0 && i !== 1) {
                      if (hideTreeIndex === 0) { hide(matched,    jsonID, visible) }
                      if (hideTreeIndex === 1) { hide(unmatched,  jsonID, visible) }
                      if (hideTreeIndex === 2) { hide(existing,   jsonID, visible) }
                      if (hideTreeIndex === 3) { hide(demolition, jsonID, visible) }
                      if (hideTreeIndex === 4) { hide(disabled,   jsonID, visible) }
                    }
                    i++;
                  })
                  break;
                }
    
                case 'reset':
                 
                  console.log("reset was clicked:  ",data.state);
              //    KeepSelected.current = [];
               selectors={
                prevMeshes: 'prevMeshes',
                prevMaterials: 'prevMaterials',
                color: 'blue',
                treeIndex: 0,
              }
               resetSelection (matched, selectors)
                selectors={
                  prevMeshes: 'prevUnmatchedMeshes',
                  prevMaterials: 'prevUnmatchedMaterials',
                  color: 'red',
                   treeIndex: 1,
                }
                resetSelection (unmatched, selectors)
                
                
                resetMatchedToUnmatched(matched, unmatched)
                
                  
                break;
            
            
              default:
                break;
            }
              
              break;
      
        default:
          console.log("Unvalid message! Due to unrecognized header:  ",data.header);
          break;
      }
    }
   
  };
  
  wss.onclose = function(event) {
    console.log('WebSocket closed:', event.code, event.reason);
    wss.isAlive = false;
    setWs(null);
    
    // Only reconnect if not intentionally closed and under max attempts
    if (!isIntentionalClose.current && reconnectAttemptsRef.current < maxReconnectAttempts) {
      reconnectAttemptsRef.current++;
      const timeout = Math.min(10000, 1000 * Math.pow(1.5, reconnectAttemptsRef.current - 1));
      console.log(`Reconnecting in ${timeout}ms... (attempt ${reconnectAttemptsRef.current})`);
      
      reconnectIntervalRef.current = setTimeout(() => {
        createWebSocketConnection();
      }, timeout);
    }
  };
  
  wss.onerror = function(error) {
    console.log('WebSocket error', error);
  };
  
  return wss;
}, [wsSessionId]);


// Replace the existing WebSocket useEffect with this:
useEffect(() => {
  // Only connect WebSocket after data is initialized
  if (wsSessionId && userId && isDataInitialized) {
    isIntentionalClose.current = false;
    createWebSocketConnection();
  }
  
  return () => {
    isIntentionalClose.current = true;
    if (reconnectIntervalRef.current) {
      clearTimeout(reconnectIntervalRef.current);
    }
    if (ws) {
      ws.close();
    }
  };
}, [userId, wsSessionId, isDataInitialized]);









    // project files variables
 
    const { request: initializeAPI } =  useHttp({

      requestCallback: async ()   =>  {
        console.warn('[DIAG] initializeAPI START — fetching json=', neededSession?.json,
          'pathsmapping.len=', neededSession?.zipInfo?.pathsmapping?.length ?? 0);
        return await getJsonFile(neededSession.json).then(async res => {
        //console.log("initializeAPI",res);
        googleAnalytics4(userId)

          // Filter pass: streaming-pipeline files (manifest, tiles/, fragments/,
          // library.*) live in pathsmapping/paths but are consumed by
          // StreamingLoader directly via manifestUrl, NOT by this loop. See
          // ModelViewer.jsx for full rationale. We filter both arrays in
          // lockstep because they are zipped by index downstream.
          const rawMapping = neededSession?.zipInfo?.pathsmapping ?? [];
          const rawPaths = neededSession?.zipInfo?.paths ?? [];
          const legacyMapping = [];
          const legacyPaths = [];
          for (let i = 0; i < rawMapping.length; i++) {
            if (isStreamingPipelineEntry(rawMapping[i])) continue;
            legacyMapping.push(rawMapping[i]);
            legacyPaths.push(rawPaths[i]);
          }

          legacyMapping.forEach(fname => {
           
            console.log("console.log(fname);",fname);
            if(fname.endsWith('.json') || fname.endsWith('.json.gz')) 
           {
             
             setModelNumber(modelNumber)
             modelNumber = modelNumber+1
            var fileName = fname.split('.')[0];
            
            modelsNames.push(fileName)
             setModelsNames(modelsNames)
           }
          });
          var baseURL = url;
              if (project?.isIfcProject) {
                baseURL = project.isIfcProject ? IFC_Url : url;
              }else if (neededSession?.isIfcProject)
              {
                baseURL = neededSession.isIfcProject ? IFC_Url : url;
              }
           
          
          legacyPaths.forEach((path) => {
            if (path.endsWith(".glb") || path.endsWith(".glb.gz")) {
              models.push(`${baseURL}/${path}`);
              console.log("console.log(models);",models);
            } else if (path.endsWith(".json") || path.endsWith(".json.gz")) {
              jsons.push(`${path}`);
            }
          });
  
  
          setModels(models)
             setJsons(jsons)

  
          // === Cache-bust per export (2026-05-25) =========================
          // The manifest URL `uploads/{projectId}/manifest.json.gz` is
          // INVARIANT for a given project — every re-export overwrites
          // the same R2 object. CefSharp's IDBBlobCache keys by URL,
          // so a re-export was returning the PREVIOUS manifest from
          // IndexedDB even though R2 had the new bytes. Same for tile
          // sidecars at `tiles/X/Y.json.gz` — stable URLs reused by
          // the new export shipped stale data to the renderer.
          //
          // Cache-bust is now content-driven inside ManifestLoader:
          // it parses an export-version token out of manifest.projectName
          // (the plugin-side timestamp suffix that changes on every
          // re-export) and auto-wraps the sidecarUrlBuilder + threads
          // the version into GLBFetcher. The manifest fetch itself
          // uses `cache: 'no-cache'` + the server sends
          // `Cache-Control: no-cache, must-revalidate` for
          // manifest.json.gz, so CefSharp's HTTP cache revalidates
          // via R2's ETag on every request. Net effect: a fresh
          // export is detected automatically — no wsSessionId / manual
          // refresh / page reload required.
          // The live version's own manifest (helpers/liveManifest); its
          // sidecars sit beside it, in the version folder.
          const manifestUrl = baseURL === url ? await liveManifestUrl(projectId) : legacyManifestUrl(baseURL, projectId);
          const sidecarBase = manifestUrl.replace(/\/manifest\.json\.gz$/i, '');
          WebGL.current = new WebGlApp(
            viewerRef.current,
              {
                glbs: models,
                // baseURL was computed earlier in this function (defaults to `url`,
                // switches to IFC_Url for IFC projects). Reuse it so streaming tracks
                // the same routing as the rest of the asset pipeline.
                manifestUrl,
                sidecarUrlBuilder: (tileId, relativeUrl) =>
                  `${sidecarBase}/${relativeUrl}.gz`,
              },
            {
              setClickedChild,
              setLoading,
              setError,
              setPercentsLoaded,
              setAllowToResize,
              setModal,
           //   setCoordsForPopover,
              findInJsonUsingViewer,
           //   setIsPopOver,
              onHoverMesh,
              
              
              
            selectedMesh,
            project,
            setPayload,
            },
            null,
            true,
            (project?.isIfcProject? project?.isIfcProject :(neededSession?.isIfcProject? neededSession?.isIfcProject : false))
          );
          attachBuildingGrid(WebGL.current?.viewer, projectId);
          console.warn('[DIAG] WebGlApp constructed — viewer=',
            !!WebGL.current?.viewer, 'streaming=', !!WebGL.current?.viewer?.streaming);
          return res;
        });
      },
      onLoad: async res => {

       // console.log("res",res)
  
        matched.current = await generateSubprojectHashmap(res.$id,res.SubProjects)
        unmatched.current = await generateSubprojectHashmap(res.$id,res.UnmatchedSubProjects)
        existing.current = await generateSubprojectHashmap(res.$id,res.ExistingSubProjects)
        demolition.current = await generateSubprojectHashmap(res.$id,res.DemolitionSubprojects)
        // NEW: disabled hashmap. Defaults to empty array if backend is older.
        disabled.current = await generateSubprojectHashmap(res.$id, res.DisabledSubprojects || [])


        meshes.current = await generateSubprojectMeshesHashed(res.SubProjects);
        unmatchedMeshes.current  = await generateSubprojectMeshesHashed(res.UnmatchedSubProjects);
        existingMeshes.current  = await generateSubprojectMeshesHashed(res.ExistingSubProjects);
        demolitionMeshes.current  = await generateSubprojectMeshesHashed(res.DemolitionSubprojects);
        // NEW
        disabledMeshes.current = await generateSubprojectMeshesHashed(res.DisabledSubprojects || []);{eventTrack("SocketView-Action","Socket3dView-opened",history.location.pathname,userId,false,wsSessionId)}
                // console.log('initializeAPI loaded')
        
        // Set flag to indicate data is initialized
        setIsDataInitialized(true);
      },
      onError: e => {
        console.warn('[DIAG] initializeAPI onError:', e?.message || e);
        console.error(e);
        setError(true);
      },
    }, );


    const {  loadingAdmin, errorAdmin, request :cacheRequestAdmin   } = useHttpWithCache({
      requestCallback: () => mainAdminGetCompanies(),
      reduxSetter: (data) => {
        // Lightweight company list only. The drill-in that
        // populates companiesProjectsRedux for this companyId
        // lives in a dedicated useEffect above (gated by
        // adminDrillInFiredRef) — keeping it OUT of reduxSetter
        // sidesteps useHttpWithCache re-invoking the setter with
        // cached reduxCash on every render whose shape changed,
        // which caused a render loop (React #185) on cold deep-
        // link opens.
        //
        // CRITICAL: do NOT dispatch company_projects / all_users
        // from this lightweight call. /admin-panel returns those as
        // empty stubs after the May-24 refactor, and the drill-in
        // useEffect populates them with the real data for THIS
        // company. Dispatching the stubs here introduces a race
        // where a late-arriving lightweight response can wipe out
        // the drill-in's good data, leaving findSession() stuck
        // and the spinner spinning forever.
        dispatch(mainAdminSetCompanies(data.company));
      },
      reduxReset: () => {
        dispatch(mainAdminSetCompanies(null));
        dispatch({
          type: "MAIN_ADMIN_SET_ALL_COMPANIES_PROJECTS",
          payload: null,
        });
        dispatch({
          type: "MAIN_ADMIN_SET_ALL_USERS",
          payload: null,
        });
      },
      reduxCash: {
        company: companiesRedux,
        company_projects: companiesProjectsRedux,
        all_users: allUsersRedux,
      },
      allowToCash: true,
    });

  const {error: cacheError, loading: cacheLoading, errorStatus: cacheErrorStatus, request: cacheRequest, refresh } = useHttpWithCache({
    requestCallback: () =>  getProjects(),
    reduxSetter: data => {
    //  console.log('cacheRequest', data)
    dispatch(setProjects(data.projects));
    
     dispatch(setCompanyUsers(data.users));
    },
    reduxReset: () => {
      dispatch(setProjects(null));
      dispatch(setCompanyUsers(null));
    },
    reduxCash: {
      projects:  projectsRedux,
      users:  usersRedux,
    
    },
    allowToCash: true,
  });
  
  const onHoverMesh = id => {
  
    const neededMesh = meshes.current.get(id);
    setHoverMesh(neededMesh);
  };





 
  const pickMeshInNeededTree = (
    clicked,
    matched,
    setClickedChild,
    keyIsCtrl,
    selectors,
    treeIndex,
  ) => {

  //  console.log("picking mesh in needed tree ", clicked)
    //setSelectGroups([]);
    if (!clicked) {
      setModal(true);
    } else { 
      // THE RECORD, WHATEVER THE LENGTH. This only ran when more than one
      // file matched, so on a single-file project newClicked stayed undefined
      // and the lookup below asked the map for `clicked.$id` - the id of an
      // ARRAY, which is undefined - on every click. It could never resolve.
      const newClicked = recordFromClick(clicked)

      // ONE LOOKUP, AND NEITHER BRANCH WORKED (owner, 2026-10-21: "pull the
      // code and analyse first and check whether they needed it").
      //
      // `matched` is a ref holding a Map keyed by node id - that is what every
      // caller passes. The multi-file branch handed that Map to
      // findRecursiveInTreeListJsonId, which expects a LIST OF TREES: its
      // isIterable check fails on a ref object, so it returned an empty result
      // for every multi-file click. The single-file branch asked the Map for
      // `clicked.$id`, the id of an ARRAY, which is undefined. Both paths
      // resolved nothing, which is why this page has never selected its tree
      // row from a 3D click.
      //
      // findRowInNodeMap is the map-shaped version of the identity rule the
      // other viewers now use: the leaf id, then Revit's UniqueId, then $id.
      const fullPath = findRowInNodeMap(matched, newClicked)
      const path = fullPath.path || []
            
          
   
       // AND USE IT. Everything below reads clicked.UniqueId; on a
       // single-file project this swap never happened, so the uid sent to the
       // viewer and written to selectedMesh was undefined.
       clicked = newClicked
    // console.log(fullPath,clicked)
    message.current = KeepSelected.current;

    let indexStored = message.current.indexOf(treeIndex);
    selectedMesh.current = clicked.UniqueId;
    let action = 'select'
    let selectionLog = null;
    
    // Check if WebGL viewer and cachedSelection are initialized
    if (WebGL.current && WebGL.current.viewer && WebGL.current.viewer.cachedSelection) {
      selectionLog = WebGL.current.viewer.cachedSelection.get(`${treeIndex}`);
    }


    if(indexStored === -1 && selectionLog !== undefined && selectionLog !== null)
    {
      message.current.splice(0, 1,treeIndex);

     // let cachedSelection = this.cachedSelection.get(`${treeIndex}`)
   

     selectionLog.forEach((id) =>         {
          if (!message.current.includes(id)) {
            message.current.push(id)
          } 

        }) 


    }
    if (keyIsCtrl) {

      if (indexStored !== -1) {

        let itemStored = message.current.indexOf(fullPath.result.id);
       if (itemStored !== -1) {
        message.current.splice(itemStored, 1);
          action = 'deselect'

        }else{
        // Item NOT in current selection — extend selection by adding the new id
        // immediately after the tree-index header. The previous code accidentally
        // REMOVED the header (slicing it out) so subsequent ctrl-click extends
        // produced malformed messages — this is why ctrl-click never reflected
        // on the C# side.
            message.current.splice(indexStored + 1, 0, fullPath.result.id);


        }




      }else
      {
        console.log({fullPath})
        message.current.push(treeIndex,fullPath.result.id)


      }

      // No per-event setPayload here — both branches end with one
      // unified `sync` emit below. State-based protocol: every viewer-
      // originated selection change tells C# the FULL post-click state
      // and C# wipes-and-replaces. No per-event drift, no edge cases,
      // no second-setPayload-coalesces-with-first race.

    }
    else
    {

      message.current= []
      message.current.push(treeIndex,fullPath.result.id)

      // === LOCAL SINGLE-TREE-AT-A-TIME ENFORCEMENT ===
      //
      // Mirror the websocket 'click' handler's "clear all other trees"
      // rule on the SOURCE viewer. onClickChildInListSocket below only
      // resets THIS tree's prevMeshes — sibling trees keep their stale
      // highlights until something else (an inbound message, a 'reset'
      // from C#, etc.) clears them. The websocket server may not echo
      // broadcasts back to the sender, so we can't rely on that round-
      // trip; we have to do the local clear ourselves.
      //
      // Ctrl-click is intentionally exempt: the user is explicitly
      // extending across trees. resetSelection() routes through
      // onClickChildInListSocket('', false, sel, 'reset', false, null),
      // which is the same path the websocket 'reset' command uses, so
      // viewer state and any future tree UI stay consistent.
      //
      // Note on naming: this function's first parameter is named
      // `matched` and shadows the outer useRef of the same name, so we
      // route the cross-tree clear through `clearOtherTreesLocal`
      // (defined at component scope) where the outer refs are still
      // visible by their real names.
      clearOtherTreesLocal(parseInt(treeIndex, 10));
    }


      // setClickedChild(s => {
      //   if (keyIsCtrl) {
      //     if (s.find(mesh => mesh.UniqueId === clicked.UniqueId)) {
      //       const neededIndex = s.findIndex(
      //         mesh => mesh.UniqueId === clicked.UniqueId,
      //       );
      //       return [...s.slice(0, neededIndex), ...s.slice(neededIndex + 1)];
      //     }
      //     return [...s, clicked];
      //   } else {
      //     return [clicked];
      //   }
      // });


      // The row's DOM id is the node's own id - TreeViewerItem renders
      // id={item.id} - not the library's slash key.
      if (fullPath && fullPath.result && fullPath.result.id) requestScroll(fullPath.result.id);

      WebGL.current.viewer.onClickChildInListSocket(
        clicked? clicked.UniqueId : '',
        keyIsCtrl,
        selectors,
        action,
        true,
        fullPath.result.id,
      );

      // === UNIFIED SYNC EMIT ===
      //
      // Every viewer-originated selection change broadcasts its FULL post-click
      // state as a single `sync` message. The C# side's inbound 'sync' handler
      // wipes every tree and replays the body, so by the time the message lands
      // both ends hold the identical selection — no per-event drift, no
      // misinterpreted ctrlclick/deselect, no race between the local view and
      // the wire.
      //
      // `message.current` was built up by the click logic above to reflect the
      // new state across all trees:
      //   - Plain click resets it to [treeIndex, id] → only this tree has a
      //     selection on the receiving side, matching plain-click semantics.
      //   - Ctrl-click (extending) preserves prior tree entries from
      //     KeepSelected.current and adds the new id, so the sync carries the
      //     full multi-tree selection.
      //   - Ctrl-click (toggling off) splices the id out, so the receiving side
      //     ends up without it.
      //
      // The viewer's own cachedSelection is also updated (by
      // onClickChildInListSocket above) before this fires, so `case 'sync'`
      // arriving back through the websocket loop is idempotent.
      // Stamped like the canvas path: if one path stamps and the other does
      // not, C# has already switched away from the legacy verbs and the two
      // paths would be speaking different envelopes on the same socket.
      selSeqRef.current = (selSeqRef.current || 0) + 1;
      setPayload(['sync', JSON.stringify(message.current), selSeqRef.current, 'viewer']);

    }
  };

 

 
const findInJsonUsingViewer = (id, keyIsCtrl) => {
  const clickedUsualMesh = meshes.current.get(id);
  const clickedUnpricedMesh = unmatchedMeshes.current.get(id);
  const clickedExistingMesh = existingMeshes.current.get(id);
  const clickedDemolitionMesh = demolitionMeshes.current.get(id);
  // NEW
  const clickedDisabledMesh = disabledMeshes.current.get(id);

  // [PERF DIAG May-25] One-shot per session — surface the click-id-vs-
  // mesh-maps lookup so we can tell whether the streaming pipeline's
  // uniqueIds match the project-JSON uniqueIds. If they don't, the
  // click silently dies here and the user sees no highlight.
  if (!findInJsonUsingViewer.__logged) {
    findInJsonUsingViewer.__logged = true;
    const matchedSample = meshes.current.size > 0 ? Array.from(meshes.current.keys()).slice(0,2) : [];
    console.warn('[PERF findInJSON] click id=' + id +
      ' matched=' + (clickedUsualMesh ? 'HIT' : 'miss') +
      ' unmatched=' + (clickedUnpricedMesh ? 'HIT' : 'miss') +
      ' existing=' + (clickedExistingMesh ? 'HIT' : 'miss') +
      ' demolition=' + (clickedDemolitionMesh ? 'HIT' : 'miss') +
      ' disabled=' + (clickedDisabledMesh ? 'HIT' : 'miss') +
      ' | mapSizes m=' + meshes.current.size +
      ' u=' + unmatchedMeshes.current.size +
      ' e=' + existingMeshes.current.size +
      ' d=' + demolitionMeshes.current.size +
      ' di=' + disabledMeshes.current.size +
      ' | matchedKeySample=' + JSON.stringify(matchedSample));
  }

    if (clickedUnpricedMesh) {
      
      pickMeshInNeededTree(
        clickedUnpricedMesh,
        unmatched,
        setClickedUnmatchedChild,
        keyIsCtrl,
        {
          prevMeshes: 'prevUnmatchedMeshes',
          prevMaterials: 'prevUnmatchedMaterials',
          color: 'red',
          treeIndex: '1',
       
        },
        '1',
      );
    } else if (clickedExistingMesh) {
      
      pickMeshInNeededTree(
        clickedExistingMesh,
        existing,
        setClickedExistingChild,
        keyIsCtrl,
        {
          prevMeshes: 'prevExistingMeshes',
          prevMaterials: 'prevExistingMaterials',
          color: 'purple',
          treeIndex: '2',
         
        },
        '2',
      );
    }  else if  (clickedUsualMesh){
      
      pickMeshInNeededTree(
        clickedUsualMesh,
        matched,
        setClickedChild,
        keyIsCtrl,
        {
          prevMeshes: 'prevMeshes',
          prevMaterials: 'prevMaterials',
          color: 'blue',
          treeIndex: '0',
        
        },
        '0',
      );
    }else if  (clickedDemolitionMesh){
      

      pickMeshInNeededTree(
        clickedDemolitionMesh,
        demolition,
        setClickedDemolitionChild,
        keyIsCtrl,
        {
          prevMeshes: 'prevDemolitionMeshes',
          prevMaterials: 'prevDemolitionMaterials',
          color: 'brown',
          treeIndex: '3',
        
        },
        '3',
      );
    }else if (clickedDisabledMesh) {
  pickMeshInNeededTree(
        clickedDisabledMesh,
        disabled,
        /* setClickedDisabledChild */ () => {},
        keyIsCtrl,
        {
          prevMeshes: 'prevDisabledMeshes',
          prevMaterials: 'prevDisabledMaterials',
          color: 'gray',
          treeIndex: '4',
        },
        '4',
      );
    } else {
      // EVERY MAP MISSED, AND THIS USED TO DO NOTHING AT ALL (owner,
      // 2026-10-20: the viewer must work wherever the model tree is used).
      //
      // This page has NO Project Files tree - only the matched / unmatched /
      // existing / demolition / disabled trees, each a ref holding a Map, so
      // it never had the per-render-array bug the other pages did. What it
      // had was silence: a click that matched nothing returned, nothing
      // moved, and nothing said why. There is no files panel here to open, so
      // the honest fix is to say so rather than to invent one.
      console.warn('[socket-viewer] click matched no tree', {
        uniqueId: id,
        mapSizes: {
          matched: meshes.current.size,
          unmatched: unmatchedMeshes.current.size,
          existing: existingMeshes.current.size,
          demolition: demolitionMeshes.current.size,
          disabled: disabledMeshes.current.size,
        },
      });
      const loaded = meshes.current.size + unmatchedMeshes.current.size
        + existingMeshes.current.size + demolitionMeshes.current.size + disabledMeshes.current.size;
      setNoMeshReason(loaded
        ? 'This element is drawn in the model but is not in any of this view\u2019s trees - it may belong to a document this session did not load.'
        : 'The model records are still loading. Try again in a moment.');
      setModal(true);
    }

  };



  useEffect(() => {
      isMountedRef.current = true;
      if ((!usersRedux && !allUsersRedux) && (!projectsRedux && !companiesProjectsRedux ) && isMountedRef.current ) {
          // history.push('/personal-area');
          if (userRedux?.admin) {
            cacheRequestAdmin();
          }else
          {
            cacheRequest();
          }
          
      } else {
        //   initializeAPI();
      }
      return () => (isMountedRef.current = false);
    }, [projectsRedux, companiesProjectsRedux , usersRedux, allUsersRedux, userRedux]);
  


  useEffect(() => {
    if(cacheErrorStatus) {
      const stringError = String(cacheErrorStatus);
      addNotification(stringError, 'danger');
      if(stringError.toLowerCase()?.includes('unexpected token')) {
        logOut();
        history.push('/');
      }
    }
  },[cacheErrorStatus])


 // let  list = []
  const  KeepSelected  = useRef([]);
  // Remove the useMemo for WebSocket message handling since it's now in createWebSocketConnection


//  meshes.current = await generateSubprojectMeshesHashed(res.SubProjects);
//  unmatchedMeshes.current  = await generateSubprojectMeshesHashed(res.UnmatchedSubProjects);
//  existingMeshes.current  = await generateSubprojectMeshesHashed(res.ExistingSubProjects);
//  demolitionMeshes.current  = await generateSubprojectMeshesHashed(res.DemolitionSubprojects);




function moveFromTreeAtoTreeB(treeA,meshesA, treeB,meshesB, jsonID)
{

  console.log("treeA obejct",{treeA})
  console.log("treeB obejct",{treeB})
  let groupExist = false;
  let subExist = false;
  let oldgroup = findRecursiveInTreeJsonIdHashmap(treeA,jsonID).parent;
  let oldsub = findRecursiveInTreeJsonIdHashmap(treeA,oldgroup.id).parent;

  let newgroup = null;
  let newsub = null;

  const tt = treeA.current.get(jsonID);
  let newTreeItem =  JSON.parse(JSON.stringify(tt));
  
  console.log('before change',{newTreeItem})

  // newTreeItem.current.set(tt.id, {
  //   id: tt.id,
  //   parentId: tt.parentId,
  //   treeId: tt.treeId,
  //   key: tt.key,
  //   treeVisible: true,
  //   treeSelected:false,
  //   label: tt.label,
  //   meshInfo: tt.meshInfo,
  //   nodes: [],
  // }) 

  console.log("creating obejct",{newTreeItem})

  treeB.current.forEach(sub => {
    if (sub.label == oldsub.label) {
      console.log("sub exist ")
      newsub = sub;
      subExist =true;
    sub.nodes.forEach(group => {
      if (group.label == oldgroup.label) {
         console.log("group exist ")
        newTreeItem.parentId = group.id
        newTreeItem.treeId = group.treeId
        newgroup = group;
        groupExist = true;

        newTreeItem = {
          id: tt.id,
          parentId: group.id,
          treeId: group.treeId,
          key: tt.key,
          treeVisible: true,
          treeSelected:false,
          label: tt.label,
          meshInfo: tt.meshInfo,
          nodes: [],
        }
      }
    })
  }
 
    
  });

  if (!subExist) {

    console.log("sub dosen't exist ")
    console.log("tree id of treeB", treeB.current.values())
      treeB.current.set(oldsub.id,{ 
        id: oldsub.id,
        parentId: oldsub.treeId,
        treeId: oldsub.treeId,
        treeVisible: true,
        treeSelected:false,
        key: oldsub.id,
        label: oldsub.label,
        nodes: []})
      }else {
        console.log("sub exist ")
        console.log("newsub.id", newsub.id)
        treeB.current.set(newsub.id,{ 
          id: newsub.id,
          parentId: newsub.treeId,
          treeId: newsub.treeId,
          treeVisible: true,
          treeSelected:false,
          key: newsub.id,
          label: newsub.label,
          nodes: newsub.nodes})
      }
    
      if (!groupExist && subExist) {
        console.log("group  dosen't exist but subExist  exist ")
        console.log("oldgroup.id", oldgroup.id)
        treeB.current.set(oldgroup.id,{ 
          id: oldgroup.id,
          parentId: newsub.id,
          treeId: newsub.treeId,
          treeVisible: true,
          treeSelected:false,
          key: oldgroup.id,
          label: oldgroup.label,
          nodes: []})


        }

        if (!groupExist && !subExist) {

          console.log("group  dosen't exist and sub dosent exist ")
          treeB.current.set(oldgroup.id,{ 
            id: oldgroup.id,
            parentId: oldsub.id,
            treeId: oldsub.treeId,
            treeVisible: true,
            treeSelected:false,
            key: oldgroup.id,
            label: oldgroup.label,
            nodes: []})
  
  
          }

          console.log("before set obejct",newTreeItem.current)

          
  // const newTreeItem = treeA.current.get(jsonID);
  // const hash = new Map()
  // hash.set(jsonID, newTreeItem)
 
  // treeB.current.copy(hash)
  // treeA.current.delete(jsonID)

  console.log('after change',{newTreeItem})
  console.log("treeB.current before set obejct",treeB.current)
    treeB.current.set(newTreeItem.id,  newTreeItem)
    meshesB.current.set(newTreeItem.meshInfo.UniqueId, newTreeItem.meshInfo)
    console.log("treeB.current after set obejct",treeB.current)
    treeA.current.delete(jsonID)
    meshesA.current.delete(newTreeItem.meshInfo.UniqueId)
    
}



const mergeTree = (treeOne, treeTwo) => {
  const newTree = new Map(treeOne.current);

  for (let [key, value] of treeTwo.current) {
    newTree.set(key, value);
  }
  return newTree
}

  function resetMatchedToUnmatched(treeData, treeUnmatchedData)
  {
 
 const mergedTree = mergeTree(treeData,treeUnmatchedData )
   treeData.current = new Map();
   treeUnmatchedData.current =  mergedTree;
  
  }




  function arrayRemove(arr, value) { 
    arr.splice(arr.findIndex(e => e.name === value),1);
  }



  function hide(tree, jsonID, visible){
       const newTreeItem = tree.current.get(jsonID);
          console.log("newTreeItem ",newTreeItem);
          if (!newTreeItem) return;

          const store = WebGL.current?.viewer?.streaming?.state;

          if (!newTreeItem.meshInfo?.UniqueId) {
            // Remote section-hide: streaming path needs explicit bulk call since groups have no UniqueId.
            if (store) {
              const uids = extractLeafUids(newTreeItem);
              if (uids.length > 0) {
                if (visible === false) {
                  newTreeItem.treeVisible = false;
                  store.hideGroup(newTreeItem.id, uids);
                } else if (visible === true) {
                  newTreeItem.treeVisible = true;
                  store.bulkShow(uids);
                }
              }
            }
            // Non-streaming fallback: existing leaf-only behavior — groups
            // are handled by another path locally, so return early here.
            return;
          }

            console.log("newTreeItem ",newTreeItem);

    // Streaming-aware: when viewer.streaming.state is wired, route
    // through the store so the change participates in applicator
    // composition (isolate/highlight/promotion). The legacy
    // UpdateGroupVisibility path writes directly to instanceMatrix and
    // gets reverted on the next applicator full-sweep (isolate toggle,
    // tile re-materialize after unload, LOD swap on a cached entry),
    // so collaborative hides on streaming sessions look like they
    // "snap back" after a few seconds.
    //
    // We still mirror treeVisible into the local tree node because
    // other code paths in this file read it to decide UI state for
    // the row.
    const uid = newTreeItem.meshInfo.UniqueId;
    if (store) {
      if (newTreeItem.treeVisible === true && visible === false) {
        newTreeItem.treeVisible = false;
        store.hide(uid);
      } else if (newTreeItem.treeVisible === false && visible === true) {
        newTreeItem.treeVisible = true;
        store.show(uid);
      }
      return;
    }

    if (newTreeItem.treeVisible === true && visible === false )
    {
      newTreeItem.treeVisible = false;

        if (newTreeItem.treeVisible === false) {
          (function disable(tree) {
            tree.treeVisible = false;
            if (tree.meshInfo) {
              let temp = WebGL.current.viewer.meshesObject.get(
                tree.meshInfo.UniqueId,
              );
              if (temp) UpdateGroupVisibility(temp, false);
            }

           //  disable(item);
          })(newTreeItem);
        }

    } else { if (newTreeItem.treeVisible === false && visible === true )
       {
        newTreeItem.treeVisible = true;
        (function enable(tree) {
          tree.treeVisible = true;
          if (tree.meshInfo) {
            let temp = WebGL.current.viewer.meshesObject.get(
              tree.meshInfo.UniqueId,
            );
            if (temp) UpdateGroupVisibility(temp, true);
          }
          // enable(tree);
        })(newTreeItem);
      }
    }

  }
  
  
  
  // Clears every tree EXCEPT the one identified by `keepTreeIndex`.
  // Same shape used by the websocket 'click' handler when arr.length > 1
  // — kept in this single helper so local-3D-click and remote-message
  // paths converge on the exact same per-tree selectors and the same
  // resetSelection routing, which feeds onClickChildInListSocket('reset')
  // and revert prevMeshes / prevMaterials on the viewer.
  //
  // Defined at component scope (not inside pickMeshInNeededTree) so the
  // tree refs `matched`, `unmatched`, `existing`, `demolition`,
  // `disabled` resolve to the outer useRef objects rather than the
  // shadowing parameter named `matched` in pickMeshInNeededTree.
  const clearOtherTreesLocal = (keepTreeIndex) => {
    const allTrees = [
      { tree: matched,    sel: { prevMeshes: 'prevMeshes',           prevMaterials: 'prevMaterials',           color: 'blue',   treeIndex: 0 } },
      { tree: unmatched,  sel: { prevMeshes: 'prevUnmatchedMeshes',  prevMaterials: 'prevUnmatchedMaterials',  color: 'red',    treeIndex: 1 } },
      { tree: existing,   sel: { prevMeshes: 'prevExistingMeshes',   prevMaterials: 'prevExistingMaterials',   color: 'purple', treeIndex: 2 } },
      { tree: demolition, sel: { prevMeshes: 'prevDemolitionMeshes', prevMaterials: 'prevDemolitionMaterials', color: 'brown',  treeIndex: 3 } },
      { tree: disabled,   sel: { prevMeshes: 'prevDisabledMeshes',   prevMaterials: 'prevDisabledMaterials',   color: 'gray',   treeIndex: 4 } },
    ];
    allTrees.forEach(({ tree, sel }) => {
      if (sel.treeIndex !== keepTreeIndex) {
        resetSelection(tree, sel);
      }
    });
  };

  function resetSelection (tree, selectors)  {
   
    if (!WebGL.current || !WebGL.current.viewer) {
      console.log('WebGL viewer not initialized yet');
      return;
    }
    
    if (!tree) {
      console.log('Tree is null or undefined');
      return;
    }

    // Map.prototype.forEach (ES2015) is universally available — including
    // on the older CEF/Chromium that CefSharp embeds. The previous form
    // `tree.current.keys().forEach(...)` relied on Iterator.prototype.forEach
    // (Iterator helpers, Stage 4 in 2024 / Chrome 122+), which throws
    // "forEach is not a function" on every CEF version older than that.
    //
    // Before the local-cross-tree-clear was added in pickMeshInNeededTree,
    // resetSelection only ran in response to inbound websocket commands
    // ('reset' / 'click' arr.length>1) — a path that may not have fired
    // during ordinary CefSharp use, so this latent incompatibility went
    // unnoticed. Now every plain local 3D click routes through here, so
    // a single click on the wrong CEF would tear down all subsequent
    // event dispatch (the throw escapes the mouseup handler and Three's
    // animate loop never recovers, hence "selection still works the first
    // time, but mouse events and toolbar buttons stop responding after").
    //
    // Map.prototype.forEach signature is (value, key, map), so we get the
    // tree item directly without re-resolving via .get().
    tree.current.forEach((newTreeItem) => {
      if (newTreeItem) {
        (function enable(node) {
          if (node.meshInfo?.UniqueId) node.treeSelected = false;
        })(newTreeItem);
      }
    });
  
    WebGL.current.viewer.onClickChildInListSocket(
      '',
      false,
      selectors,
      'reset',
      false,
      null,
     )
       
       
   
         selectedMesh.current = null;
     
   
     
     
      
      
   

    }
  

    function selectClick (tree, jsonID, selectors, isControl)  {

      if (!WebGL.current || !WebGL.current.viewer) {
        console.warn('[PERF selectClick] WebGL viewer not initialized yet');
        return;
      }

      if (!tree) {
        console.warn('[PERF selectClick] Tree is null or undefined');
        return;
      }

      const newTreeItem = tree.current.get(jsonID);
       if (!newTreeItem?.meshInfo?.UniqueId) {
         // [PERF DIAG] One-shot per session — log the tree size + a
         // sample key so we can tell whether the tree is empty, the
         // jsonID isn't in this bucket, or the meshInfo is missing.
         if (!selectClick.__missLogged) {
           selectClick.__missLogged = true;
           const treeSize = tree?.current?.size ?? -1;
           const sampleKeys = treeSize > 0 ? Array.from(tree.current.keys()).slice(0, 3) : [];
           const hit = tree?.current?.get(jsonID);
           console.warn('[PERF selectClick] MISS treeIndex=' + selectors?.treeIndex +
             ' lookForJsonID=' + jsonID +
             ' treeSize=' + treeSize +
             ' sampleKeys=' + JSON.stringify(sampleKeys) +
             ' hitShape=' + (hit ? Object.keys(hit).slice(0,8).join(',') : 'undef'));
         }
         return;
       }
       
       
   
         selectedMesh.current = newTreeItem.meshInfo?.UniqueId;
     
     
        {
           (function enable(tree) {
             if ( tree.meshInfo?.UniqueId)

               tree.treeSelected = true
           })(newTreeItem);
         }
      
   
         WebGL.current.viewer.onClickChildInListSocket(
          newTreeItem.meshInfo?.UniqueId,
          isControl,
          selectors,
          'select',
          false,
          jsonID,

         )
       
   
   
   
       
     
      }


        function deselectClick (tree, jsonID, selectors)  {

          if (!tree) {
            console.log('Tree is null or undefined');
            return;
          }
  
          const newTreeItem = tree.current.get(jsonID);
            if (!newTreeItem?.meshInfo?.UniqueId) 
              return;
            
            
        


            selectedMesh.current = null;
        
                           
          
            {
                (function enable(tree) {
                  if ( tree.meshInfo?.UniqueId)
        
                    tree.treeSelected = false
                })(newTreeItem);
              }
          
        
              WebGL.current.viewer.onClickChildInListSocket(
              newTreeItem.meshInfo?.UniqueId,
              false,
              selectors,
              'deselect',
              false,
              jsonID,
    
              )
         
        
        
        
            
          
          }


// Update the send message logic to check WebSocket state
useMemo(() => {
  if (ws && ws.readyState === WebSocket.OPEN && payload) {
    var message = JSON.stringify({
      roomid: `${wsSessionId}`,
      header: 'action',
      state: `${payload[0]}`,
      body: `${payload[1]}`,
        // seq and origin, per the selection-sync contract (desktop agent,
        // 2026-09-27). seq is per-sender and monotonic FOR TRACING ONLY -
        // deliberately NOT a drop rule, because a reloaded viewer restarts
        // at 1 and must not be rejected by a peer that has seen 40.
        // origin lets C# know a contract-aware viewer is talking, at which
        // point it stops obeying the legacy click/ctrlclick/deselect verbs.
        ...(payload[2] !== undefined ? { seq: payload[2] } : {}),
        ...(payload[3] !== undefined ? { origin: payload[3] } : {}),
    }, null, '\t');
    
    try {
      ws.send(message);
    } catch (error) {
      console.log(error);
    }
  } else if (payload) {
    console.log('WebSocket not ready, skipping message');
  }
}, [payload, ws, wsSessionId]);

  return (
    <MDBBox className="socketviewer d-flex overflow-hidden position-relative">
      {/* Debug overlay (top-right): GPU acceleration status + rolling FPS.
          Visible ONLY in dev environments (localhost / predeployment).
          When CefSharp Accelerated Paint OSR is working it should show
          "GPU: <hardware renderer string>" — a "SwiftShader" or similar
          value means we're back on slow software-rasterized OSR. */}
      {isDebugOverlayEnabled && (
        <div
          style={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 9999,
            background: 'rgba(0,0,0,0.65)',
            color: '#fff',
            padding: '6px 10px',
            font: '11px/1.3 monospace',
            borderRadius: 4,
            pointerEvents: 'none',
            maxWidth: 360,
            wordBreak: 'break-all',
          }}
        >
          <div>FPS: <b>{debugFps}</b></div>
          {debugGpu ? (
            <>
              <div>GPU: <b style={{ color: debugGpu.hardwareAccelerated ? '#3f6' : '#f66' }}>
                {debugGpu.hardwareAccelerated ? 'HW' : 'SW'}
              </b></div>
              <div style={{ opacity: 0.8 }}>{debugGpu.renderer}</div>
            </>
          ) : (
            <div style={{ opacity: 0.6 }}>(GPU info pending…)</div>
          )}
        </div>
      )}
      <div
      className="resize-panel"
     // style={{ width: window.innerWidth }}
      style={{ flexGrow: 1 }}

              ref={viewerRef}
            >
              {/* {isPopover ? (
                <MDBBox
                  className="position-absolute viewer-popover border border-dark"
                  style={popoverCoords}
                >
                  {hoverMeshInfo()}
                </MDBBox>
              ) : null} */}
              {loading ? (
                <MDBBox className="h-100 w-100 flex-center flex-column">
                  <Loading color="black" text="Loading model..." />
                  {percentsLoaded ? (
                    
                   //{jsonFilesMeshesToJSX},  {jsonUnmatchedMeshesToJSX},{jsonExistingMeshesToJSX},{jsonDemolitionMeshesToJSX}  ,
                    <span>{percentsLoaded}% has loaded...</span>
                  ) : null}
                </MDBBox>
              ) : null}
                {/* The shared toolbar (components/Viewer/ViewerToolbar): the model
                    view's icons, on every 3D page. This page keeps its OWN
                    placement class - it is the desktop-embedded viewer and
                    nobody here can see that window to judge a move - and it
                    asks for no grid, because its Grid button never carried an
                    id and so could never light. The buttons below are its own,
                    and its enable/disable has a C# websocket counterpart. */}
                <ViewerToolbar
                  viewer={() => WebGL.current && WebGL.current.viewer}
                  groupClassName="modal3d-tool-group-btn"
                  tools={["reload","zoomIn","zoomOut","screenshot","home","target","measure","section","isolate","hide","unhide"]}
                >
                <MDBBtn
                    id="enableDisableElementsBtn"
                    title="Enable/Disable Elements — toggle visibility of components currently in the Disabled tab. OFF (default) = disabled+hidden. ON = disabled (gray) but visible. Precedence: explicit Hide and active Isolation still win."
                    size="sm"
                    color=""
                    className="bg-white modal3d-tool-btn"
                    onClick={(e) => {
                      // Tree-4 membership puts uids in the disabled bucket
                      // (gray ghosted) — that's set up automatically by the
                      // 'move' handler and on initial load via the
                      // 'toggleDisabled' WS message. This button only flips
                      // whether those gray items are ALSO in the hidden
                      // bucket: hidden bucket wins over disabled per the
                      // locked-in precedence Hidden > Isolated > Disabled,
                      // so adding to hidden makes them invisible; removing
                      // reverts to gray-and-visible.
                      const willShow = !e.currentTarget.classList.contains('buttonEnabled');
                      e.currentTarget.classList.toggle('buttonEnabled');
                      showDisabledRef.current = willShow;

                      // Apply LOCALLY first for immediate visual feedback.
                      // Source of truth = `disabled.current` Map (runtime
                      // tree-4 contents). Previously we walked
                      // disabledTreeUidsRef, which C# overwrites with its
                      // export-time list on every toggleDisabled handshake
                      // — so runtime drags-into-disabled were silently
                      // dropped on the next C# round-trip. The Map is
                      // updated atomically by every 'move' handler, so
                      // it's always current. Translate jsonId →
                      // meshInfo.UniqueId via the Map entries themselves.
                      const store = WebGL.current?.viewer?.streaming?.state;
                      const jsonIds = Array.from(disabled.current.keys());
                      let resolved = 0, unresolved = 0;
                      if (store && jsonIds.length > 0) {
                        jsonIds.forEach(jsonId => {
                          try {
                            const entry = disabled.current.get(jsonId);
                            const realUid = entry?.meshInfo?.UniqueId;
                            if (!realUid) { unresolved++; return; }
                            resolved++;
                            store.disable(realUid);
                            if (willShow) store.show(realUid);
                            else store.hide(realUid);
                          } catch (err) {}
                        });
                      } else if (!store) {
                        applyDisabledBucketWithRetry();
                      }
                      console.log('[EnableDisable] click willShow=', willShow,
                                  'totalUids=', jsonIds.length,
                                  'resolved=', resolved, 'unresolved=', unresolved,
                                  'storeReady=', !!store);

                      // Also round-trip to C# so its Disabled-tab toggle
                      // mirrors. C# echoes back the full {visible, uids}
                      // payload; our inbound handler resyncs
                      // disabledTreeUidsRef (in case items moved while
                      // disconnected) and re-applies — idempotent.
                      try {
                        if (ws && ws.readyState === 1) {
                          // roomid is required so the relay routes the message
                          // to the C# client subscribed to this session. Other
                          // outbound sends in this file (e.g. requestSync at
                          // line 471) include it; without it the message is
                          // silently dropped at the relay and C# never sees it.
                          ws.send(JSON.stringify({
                            roomid: `${wsSessionId}`,
                            header: 'action',
                            state: 'toggleDisabled',
                            body: JSON.stringify(willShow),
                          }));
                        }
                      } catch (err) {
                        console.warn('[EnableDisable] WS send failed:', err);
                      }
                    }}
                  >
                    <MDBIcon icon="power-off" className="font-size-1" />
                  </MDBBtn>
                  <MDBBtn
                    id="outlierBboxesToggleBtn"
                    title="Toggle tile bounding-box wireframe overlay (debug)"
                    size="sm"
                    color=""
                    className="bg-white modal3d-tool-btn"
                    onClick={(e) => {
                      // Streaming may not be active (legacy projects) — guard the call.
                      WebGL.current.viewer.streaming.toggleShowOutlierBboxes();
                      e.currentTarget.classList.toggle('buttonEnabled');
                    }}
                  >
                    <MDBIcon icon="border-style" className="font-size-1" />
                  </MDBBtn>

                </ViewerToolbar>
             {/* </MDBBtnGroup> */}
            </div>
         
      <NoMeshModal isOpen={modal} reason={noMeshReason} toggle={() => { setModal(s => !s); setNoMeshReason(''); }} />
      
    </MDBBox>
  );
};

export default SocketViewer;